// GettingStartedColumnRow — one column of the open import preview (POB S10,
// pages/gettingStartedImports.js): its name, a few of its values, and the
// field of the chosen app it goes into ("Skip this column" when nothing
// matched it) — or, for a collection with no fields declared, "Add as a new
// field".
//
// The row state is the column (functions/gettingStartedImports.js
// gettingStartedImportColumns — `column*` fields, so no field falls back to a
// root key). The pick lives in its own root key (`gettingStartedMapping`) and
// is read per prop: a pick re-runs this row's select and never rebuilds the
// list, so the select keeps focus. Phone and a narrow pane: the select goes
// under the name.
export const GettingStartedColumnRow = {
  flow: 'x',
  align: 'center',
  gap: 'A',
  padding: 'Z A',
  '@mobileL': { flow: 'y', align: 'stretch', gap: 'Z' },
  '@appMobile': { flow: 'y', align: 'stretch', gap: 'Z' },

  GscrWho: {
    flow: 'y',
    gap: 'X',
    flex: '1 1 0',
    minWidth: '0',
    GscrName: {
      tag: 'span',
      fontSize: 'Z2',
      fontWeight: '500',
      color: 'title',
      overflowWrap: 'anywhere',
      text: (el, s) => s.columnLabel
    },
    GscrSamples: {
      tag: 'span',
      fontSize: 'Z',
      color: 'caption',
      overflowWrap: 'anywhere',
      hide: (el, s) => !s.columnSampleText,
      text: (el, s) => s.columnSampleText
    }
  },

  GscrField: {
    flex: '0 1 G',
    minWidth: '0',
    '@mobileL': { flex: 'none', width: '100%' },
    '@appMobile': { flex: 'none', width: '100%' },

    AppSelectCompact: {
      // The mapping is a draft the page keeps, not unsaved work to guard: a
      // pane close keeps it, so no "Discard changes?".
      dirty: false,
      ariaLabel: (el, s) => {
        void s.root?.lang
        return el
          .call('polyglot', 'workspace.gettingStarted.imports.fieldAria')
          .replace('{column}', s.columnLabel)
      },
      value: (el, s) => {
        void s.root.gettingStartedMapping
        return el.call('gettingStartedImportPick', s.root, s.columnKey)
      },
      onChange: (e, el, s) =>
        el.call('setGettingStartedImportMapping', s.root, s.columnKey, e.target.value),
      childExtends: 'AppOption',
      children: (el, s) => {
        void s.root?.lang
        void s.root.gettingStartedMapping
        void s.root.gettingStartedTargets
        return el.call('gettingStartedImportFieldOptions', s.root, s.columnKey, {
          skip: el.call('polyglot', 'workspace.gettingStarted.imports.skip'),
          required: el.call('polyglot', 'workspace.gettingStarted.imports.required'),
          newField: el.call('polyglot', 'workspace.gettingStarted.imports.newField')
        })
      }
    }
  }
}
